import { Tooltip } from '@chakra-ui/react';
import { ReactElement, ReactNode, useState } from 'react';
import { deafultTooltipProps } from './constants';
import './style.scss';

const CustomTooltip = ({
  children,
  showTooltip,
  title,
  position,
  tooltipStyle = {},
}: {
  children: ReactNode;
  showTooltip: boolean;
  title: string;
  position: string | any;
  tooltipStyle?: Object;
}): ReactElement => {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <div
      onMouseOver={() => {
        setIsVisible(true);
      }}
      onMouseOut={() => {
        setIsVisible(false);
      }}
      onClick={() => {
        setIsVisible(true);
        setTimeout(() => setIsVisible(false), 4000);
      }}
      className="cursor-default">
      <Tooltip
        className="tooltip-custom"
        isOpen={showTooltip && isVisible}
        hasArrow
        placement={position}
        label={title}
        {...deafultTooltipProps}
        {...tooltipStyle}>
        {children}
      </Tooltip>
    </div>
  );
};

export default CustomTooltip;
